import { defineMessages } from 'react-intl';

export default defineMessages({
  courseUrl: {
    id: '/course',
    defaultMessage: '/course',
  },
  coursesUrl: {
    id: '/courses',
    defaultMessage: '/courses',
  },
  servicesUrl: {
    id: '/services',
    defaultMessage: '/services',
  },
  serviceUrl: {
    id: '/service',
    defaultMessage: '/service',
  },
  payment: {
    id: 'payment',
    defaultMessage: 'payment',
  },
  course: {
    id: 'course',
    defaultMessage: 'course',
  },
});
